import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { getIsUserSignedIn } from "@gamedev-web/gamedev-sdk-core";
import { RouteNames } from "../partnerConfig/routeNames";
import { OnboardingUrls } from "../partnerConfig/routes";
import { capabilitiesActions } from "../redux/actions/capabilitiesActions";
import { getIsInitialCrmFetchDone } from "../redux/selectors";
import { getIsAaaUser } from "../redux/selectors/capabilitiesSelectors";

export const useOnProgramSelectionPageLoad = async () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const isSignedIn: boolean = useSelector(getIsUserSignedIn);
  const isInitialCrmFetchDone = useSelector(getIsInitialCrmFetchDone);
  const isAaaUser = useSelector(getIsAaaUser);

  useEffect(() => {
    if (!isSignedIn || isInitialCrmFetchDone) {
      return;
    }

    dispatch(capabilitiesActions.updateCapabilities.start());
  }, [dispatch, isSignedIn, isInitialCrmFetchDone]);

  useEffect(() => {
    if (isAaaUser) {
      history.replace(OnboardingUrls[RouteNames.AaaWelcome]);
    }
  }, [dispatch, isAaaUser, history]);
};
